export { combineClassNames } from "./Utils";

export const getSupportedFileTypes = (arr, prefix = "", islower = null) => {
	if (!Array.isArray(arr)) return "";

	const filesTypes = arr.map((item) => {
		const type = `${prefix}${
			islower === null
				? item
				: islower
				? item.toLowerCase()
				: item.toUpperCase()
		}`;
		return type;
	});

	return filesTypes.join(", ");
};
